import {
  getAllCrewEmployeeSuccess,
  getAllCrewEmployeeFail,
  addNewCrewEmployeeFail,
  addNewCrewEmployeeSuccess,
  editExistingCrewEmployeeFail,
  editExistingCrewEmployeeSuccess,
  deleteExistingCrewEmployeeFail,
  deleteExistingCrewEmployeeSuccess
} from "../constants/crewEmployee";

// Initial state updated to reflect that `data` is an object with `object` (array) and `totalCount`.
const initialState = {
  isProcessing: false,
  isError: false,
  addNewEmployeeError: false,
  editEmployeeError: false,
  deleteEmployeeError: false,
  data: { object: [], totalCount: 0 }, // Updated to reflect API response structure.
};

const handleReducer = (state, action) => {
  switch (action.type) {

    case getAllCrewEmployeeSuccess:
      return {
        ...state,
        data: {
          object: action.payload.object, // Assigning array of employees to `object`
          totalCount: action.payload.totalCount, // Assigning `totalCount` property
        },
      };

    case getAllCrewEmployeeFail:
      return {
        ...state,
        isError: true,
      };

    case addNewCrewEmployeeSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: [...state.data.object, action.payload], // Adding new employee object to the `object` array
        },
      };

    case addNewCrewEmployeeFail:
      return {
        ...state,
        addNewEmployeeError: true,
      };

    case deleteExistingCrewEmployeeSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: state.data.object.filter((user) => user.employeeId !== action.payload), // Removing employee by `employeeId`
        },
      };

    case deleteExistingCrewEmployeeFail:
      return {
        ...state,
        deleteEmployeeError: true,
      };

    case editExistingCrewEmployeeSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: state.data.object.map((user) =>
            user.employeeId === action.payload.employeeId ? { ...user, ...action.payload } : user
          ), // Updating employee data in the `object` array
        },
      };

    case editExistingCrewEmployeeFail:
      return {
        ...state,
        editEmployeeError: true,
      };

    default:
      return state;
  }
};

export const crewEmployeeReducer = (state = initialState, action = {}) => {
  return handleReducer(state, action);
};
